export default class SlaModel {
    constructor () {

        this.id = null
        this.client_id = null
        this.contact_id = null
        this.user_id = null
        this.lead_type = ""
        this.status = "Draft"
        this.due_date = null,
        this.client_budget = 0
        this.project_value = 0
        this.license_fee = 0
        this.margin = 0
        this.retainer_id = null
    }
}
